import axios from "axios";
import Vue   from "vue";
import Vuex  from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
    state     : {
        user : {
            perfis : []
        }
    },
    mutations : {
        setUser(state, user) {
            state.user = user;
            if (user) {
                axios.defaults.headers.common['Authorization'] = `Bearer ${user.accessToken}`;
            } else {
                delete axios.defaults.headers.common['Authorization'];
            }
        }
    },
    actions   : {}
});
